/**
 * All navigation components + dealing with styling and theming + header and footer
 */
import React, { useState } from 'react';

import { NavHeaderDiv, NavHeaderButton, NavButton, NavFooterDiv, TopNav, SideMenu } from './NavigationStyles';

import { Link } from 'gatsby';

// side menu
import { slide as Menu } from 'react-burger-menu';
// logo import
import logo from './Logo.svg';

// check window is not defined
const isBrowser = typeof window !== "undefined";

export function NavHeader() {

  return (
    <NavHeaderDiv>
      {isBrowser && <>
        <NavHeaderButton to='/' currentPage={window.location.href.endsWith('.dev/') || window.location.href.endsWith(':8000/')} aria-label='header home'>Home</NavHeaderButton>
        <NavHeaderButton to='/blog' currentPage={window.location.href.includes('/blog')} aria-label='header blog'>Blog</NavHeaderButton>
        <NavHeaderButton to='/contact' currentPage={window.location.href.endsWith('/contact') || window.location.href.endsWith('/contact/')} aria-label='header contact'>Contact</NavHeaderButton>

      </>
      }
    </NavHeaderDiv>
  );
}

export function NavFooter() {
  return (
    <NavFooterDiv id='footer'>
      <NavButton to='/resume.pdf' aria-label="footer resume">Resume</NavButton>
      <NavButton to='/contact' aria-label="footer contact">Contact</NavButton>
    </NavFooterDiv>
  );
}

/**
 * The side menu used for authenticated navigation
 * Allows users to navigate the funcitonlaity of the website
 * @returns JSX Functional Component
 */
export function ResponsiveHeader () {
  const [isOpen, setOpen] = useState(false);

  // state object is from react-burger-menu
  // Not sure what the type might be
  // Toggles the state based on isOpen
  const handleMenuStateChange = (state) => {
    setOpen(state.isOpen)
  }

  // state toggle force close on redirect via Link button
  const closeSideBar = () => {
    setOpen(false)
  }

  const handleSideButton = (location) => {
    closeSideBar();
  }

  return (
    <TopNav id='header' className="sticky-top">
      <NavHeader />
      <SideMenu >
        <Menu
          right
          isOpen={isOpen}
          onStateChange={(state) => handleMenuStateChange(state)}
          id='headerBurger'
        >
          <Link className='bm-item' to='/' onClick={() => handleSideButton()}>Home</Link>
          <Link className='bm-item' to='/blog' onClick={() => handleSideButton()}>Blog</Link>
          <Link className='bm-item' to='/contact' onClick={() => handleSideButton()}>Contact</Link>
        </Menu>
      <a id='logoLinkSideMenu' className='logo-button' href='https://johndao.dev'>
        <img src={logo} height={35} width={35} style={{marginTop: '5px'}} alt='John Dao branding logo link to go to home page'/>
      </a>
      </SideMenu>
    </TopNav>
)}
